import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error for debugging (works in both dev and production)
    // eslint-disable-next-line no-console
    console.error('Unhandled UI error:', error, errorInfo);
    
    // In production, also log to window for easier debugging
    if (process.env.NODE_ENV === 'production') {
      // Store error info for potential error reporting
      if (window && typeof window !== 'undefined') {
        window.__REACT_ERROR_BOUNDARY_ERROR__ = {
          error: error?.message || String(error),
          stack: error?.stack,
          componentStack: errorInfo?.componentStack
        };
      }
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    const isProd = process.env.NODE_ENV === 'production';
    
    // Ensure error UI is always visible, even in production
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-gray-100 dark:bg-gray-900 p-6" style={{ minHeight: '100vh' }}>
        <div className="max-w-2xl w-full bg-white dark:bg-gray-800 rounded-lg shadow-2xl p-6">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
            Something went wrong
          </h2>
          <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">
            The page crashed due to an unexpected error. Please reload the page to continue.
          </p>

          {!isProd && (
            <pre className="mt-4 text-xs overflow-auto bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 p-3 rounded">
              {String(error?.stack || error?.message || error)}
            </pre>
          )}

          {isProd && (
            <p className="mt-4 text-xs text-gray-500 dark:text-gray-400">
              Check the browser console for more details.
            </p>
          )}

          <div className="mt-4 flex gap-2">
            <button
              onClick={this.handleReload}
              className="px-4 py-2 rounded bg-gradient-primary text-white text-sm font-medium hover:opacity-90"
            >
              Reload Page
            </button>
            <button
              onClick={() => window.location.href = '/'}
              className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-sm font-medium hover:opacity-90"
            >
              Go Home
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;

